/* globals $, globalScene, allTweens, controller */
import { TimelineMax, Strong } from 'gsap';
import 'gsap/ScrollToPlugin';

import calculateOffset from 'helpers/calculateOffset';
import ScrollMagic from 'helpers/importers/ScrollMagic';

export default function historyScene () {

  let tween = new TimelineMax()
    .from($('#history > .wrapper .section-title h2'), 0.5, {
      xPercent: -120,
      opacity: 0,
      ease: Strong.easeOut,
    })
    .from($('#history .view-history'), 0.5, {
      opacity: 0,
    });


  allTweens.push(tween);

  let sceneStart = new ScrollMagic.Scene({
    triggerElement: '#history',
    offset: calculateOffset(100),
    duration: 0,
    triggerHook: 'onEnter',
  });
  //.addIndicators({name: "history"});

  let scene = new ScrollMagic.Scene({
    triggerElement: '#history',
    offset: calculateOffset(200),
    duration: 0,
    triggerHook: 'onEnter',
  })
  .setTween(tween);

  sceneStart.enabled(false);
  scene.enabled(false);

  sceneStart.addTo(controller);
  scene.addTo(controller);

  globalScene.push(sceneStart);
  globalScene.push(scene);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/historyScene.js